import React, { type ReactNode } from 'react';
import { Text } from 'src/components/text/Text';

import styles from './Badge.css';

interface Props {
  children: ReactNode;
  icon?: ReactNode;
  testAttr?: string;
  textTestAttr?: string;
}

export const Badge = ({ children, icon, testAttr, textTestAttr }: Props) => {
  return (
    <div className={styles.Badge} data-test={testAttr}>
      {icon && <div className={styles.Badge__Icon}>{icon}</div>}
      <Text as="span" variant="caption" data-test={textTestAttr}>
        {children}
      </Text>
    </div>
  );
};
